import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {GetLead_lead as Lead} from 'nutshell-graphql-types';

import {AssigneeButton} from '../../header/buttons/assignee-button';
import {HotButton} from '../../header/buttons/hot-button';
import {LeadStatusButton} from '../../header/buttons/lead-status-button';
import {WatchButton} from '../../header/buttons/watch-button';
import {LeadActionMenu} from '../../header/lead-action-menu';
import {LeadValue} from '../../header/lead-value';

import styles from '../header.module.css';

type Props = {
    lead: Lead | null | undefined;
};

export function RightSection(props: Props) {
    if (!props.lead) {
        return null;
    }

    return (
        <div className={styles['right-section']}>
            <div className='flex'>
                <div className={styles['lead-value-container']}>
                    <LeadValue
                        isHot={props.lead.isHot}
                        status={props.lead.status}
                        value={props.lead.value}
                    />
                </div>
                <div className={styles['button-row']}>
                    {NutClientConfig.hasLeadWatching ? (
                        <WatchButton lead={props.lead} />
                    ) : undefined}
                    {NutClientConfig.hasHotLeads ? <HotButton lead={props.lead} /> : undefined}
                    <div>
                        <LeadActionMenu lead={props.lead} />
                    </div>
                </div>
            </div>
            <div className={styles['select-row-container']}>
                <div className={styles['select-row']}>
                    <LeadStatusButton lead={props.lead} shouldGrow={false} />
                    <div className={styles['assignee-button']}>
                        <AssigneeButton lead={props.lead} showTooltip={true} />
                    </div>
                </div>
                {(props.lead.status === 'LOST' || props.lead.status === 'CANCELLED') &&
                    props.lead.outcome && (
                        <div className='mt-8'>
                            <Body size='small' color='inherit' truncate={{type: 'block'}}>
                                {props.lead.outcome.name}
                            </Body>
                        </div>
                    )}
            </div>
        </div>
    );
}
